import { createClient } from '../../server/client/client.no-deps'
import { LS_accessTokenGet } from './LS/LS.accessToken'
import { LS_customerGet } from './LS/LS.customer'
import { Serv_httpRequestWithOption } from './Serv/Serv.httpRequest'
import type { PushSubscription } from 'web-push'
import { timeout } from '../../shared/lib/timeout.no-deps'

const VAPID_PUBLIC_KEY = 'BF_oB5GQlSQqeOrQCs_0w5V7WYeMgB-ijD-ygjQJdtrT81ZVj2sJWEV1HszxOJ2lzJlGKazSMJFosCAWQQlhiZg'
const HOW_OFTEN = 5000

export async function initWebPushNotifications() {
    const result = await Notification.requestPermission()

    if (result === 'denied') {
        /* eslint-disable-next-line no-console */
        console.error('The user explicitly denied the permission request.')
        return
    }
    if (result === 'granted') {
        /* eslint-disable-next-line no-console */
        console.info('The user accepted the permission request.')
    }

    let registration = await navigator.serviceWorker.getRegistration()

    if (!registration) {
        registration = await navigator.serviceWorker.register('/sw.js')
    }

    let subscription = await registration.pushManager.getSubscription()

    if (!subscription) {
        subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlB64ToUint8Array(VAPID_PUBLIC_KEY),
        })
    }

    const subcriptionToSend: PushSubscription = {
        endpoint: subscription.endpoint,
        keys: subscription.toJSON().keys as PushSubscription['keys'],
    }

    // server rest call to add subscription
    trySubscribe(subcriptionToSend)
}

async function trySubscribe(subcriptionToSend: PushSubscription) {
    let continueTrying = true

    while (continueTrying) {
        if (await addSubscription(subcriptionToSend)) {
            continueTrying = false
        }

        await timeout(HOW_OFTEN)
    }
}

async function addSubscription(subcriptionToSend: PushSubscription) {
    try {
        const httpClient = createClient(
            Serv_httpRequestWithOption({ accessToken: LS_accessTokenGet(), customer: LS_customerGet() })
        )

        const resp = await httpClient.addSubscription(subcriptionToSend)

        if (!resp.success) {
            return false
        }

        return true
    } catch {
        return false
    }
}

// Convert a base64 string to Uint8Array.
// Must do this so the server can understand the VAPID_PUBLIC_KEY.
function urlB64ToUint8Array(base64String: string) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
    const rawData = window.atob(base64)
    const outputArray = new Uint8Array(rawData.length)
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i)
    }
    return outputArray
}
